'use client';

import { createContext, ReactNode, useContext } from 'react';

const TenantContext = createContext<string | null>(null);

export type TenantProviderProps = {
    children: ReactNode;
    tenant: string;
};

export function TenantProvider({ tenant, children }: TenantProviderProps) {
    return (
        <TenantContext.Provider value={tenant}>
            {children}
        </TenantContext.Provider>
    );
}

export function useTenant() {
    const tenant = useContext(TenantContext);

    if (!tenant) {
        throw new Error('TenantProvider not found');
    }

    return tenant;
}
